import { atom } from 'recoil';
import { getOnsaProgressSelector } from '../selectors/getOnsaProgressSelector';
import { type Step } from '../types/onsaTypes';

export const onsaProgressAtom = atom<Step>({
    key: 'onsaProgressState',
    default: getOnsaProgressSelector
});
